export default "__VITE_ASSET__08922417__"